@use "../../variables" as *;

$image-container-height: 150vw;
$image-container-min-height: 77vh;

.images {
  position: relative;
  top: 0;
  height: $image-container-height;
  display: block;
  overflow: scroll hidden;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;

  @media (min-aspect-ratio: 15/24) {
    height: $image-container-min-height;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .image-carousel-container {
    list-style-type: none;
    height: 100%;
    white-space: nowrap;
    overflow-x: visible;
    width: 100%;
    padding: 0;
    margin: 0;

    .image {
      overflow: hidden;
      list-style-type: none;
      display: inline-block;
      min-height: 100%;
      height: 100%;
      text-align: center;
      visibility: visible;
      margin: 0;
      width: 100vw;
      background-color: $white-bis;
      position: relative;
      scroll-snap-align: start;
    }
  }
}

.slider {
  width: auto;
  height: 0.25rem;
  position: relative;
  transform: translate(0, -98%);
  background: rgba(25, 17, 11, 0.14);

  .scrollbar-thumb {
    display: flex;
    border-radius: 0 0.25rem 0.25rem 0;
    height: 100%;
    width: 100%;
    position: relative;

    .active {
      background: $black-scrollbar;
    }
  }
}
